import { genUrlWithQuery } from '@src/api/urls';
import { Offer2 } from '@src/pages/HR/Offer2/interface';
export const defaultTabKey = Offer2.TabKeys.notRegular;
export const defaultOffer2UrlQuery = {
    tab_key: defaultTabKey,
    order_by: 'desc',
};
export const offer2Url = genUrlWithQuery('/hr/offer2');
